import React from 'react';
import { withWrapper } from '@shared/react';
import {
    PaymentRequestsTableProvider,
    usePaymentRequestsTable,
    getPaymentRequestsTableColumns,
    PAYMENT_REQUESTS_TABLE_TITLE,
    PAYMENT_REQUESTS_TABLE_INFO_URL,
} from './lib';
import { Table } from '@features/Table';
import { PaymentRequestsTableFilters } from './components';
import './PaymentRequestsTable.scss';
import { getPaymentRequestTableRows } from './lib/getPaymentRequestTableRows';

const PaymentRequestTableContent: React.FC = () => {
    const { paymentRequests, paymentRequestsLoading, paginationOptions, onPaymentRequestViewClick } =
        usePaymentRequestsTable();

    return (
        <Table
            columns={getPaymentRequestsTableColumns()}
            data={paymentRequests}
            dataLoading={paymentRequestsLoading}
            tableTitle={PAYMENT_REQUESTS_TABLE_TITLE}
            infoLink={PAYMENT_REQUESTS_TABLE_INFO_URL}
            paginationOptions={paginationOptions}
            filters={<PaymentRequestsTableFilters />}
            row={getPaymentRequestTableRows({ onPaymentRequestViewClick })}
        />
    );
};

export const PaymentRequestsTable = withWrapper(PaymentRequestsTableProvider)(PaymentRequestTableContent);
